import React, { useState, useMemo } from "react";
import { useTranslation } from "react-i18next";
import { Table } from "sulu-admin-bundle/components";
import Button from "sulu-admin-bundle/components/Button";
import Moment from "moment";
import RecapLegend from "../Table/RecapLegend";
import { renderMatchStatus } from "../Table/matchStatusUtils";
import tableStyles from "../../../css/table/TableStyles.scss";

const { Header, Body, Row, Cell, HeaderCell } = Table;

const SORT_COLUMNS = ["date", "leagueName", "team", "status"];

const COL_TRANSLATION_KEYS = {
    date: "dhb.player.recap.column.date",
    leagueName: "dhb.player.recap.column.league",
    team: "dhb.player.recap.column.team",
    status: "dhb.player.recap.column.status",
};

const PlayerRecapTable = ({ data = [], loading, onMatchClick }) => {
    const { t } = useTranslation();
    const [sortColumn, setSortColumn] = useState("date");
    const [sortOrder, setSortOrder] = useState("desc");

    const handleSort = (column) => {
        if (sortColumn === column) {
            setSortOrder((prev) => (prev === "asc" ? "desc" : "asc"));
        } else {
            setSortColumn(column);
            setSortOrder("asc");
        }
    };

    const sortedRows = useMemo(() => {
        return [...data].sort((a, b) => {
            const aVal = a[sortColumn] ?? "";
            const bVal = b[sortColumn] ?? "";
            const cmp = String(aVal).localeCompare(String(bVal));
            return sortOrder === "asc" ? cmp : -cmp;
        });
    }, [data, sortColumn, sortOrder]);

    if (loading) {
        return <div>{t("dhb.player.recap.loading")}</div>;
    }

    if (!data.length) {
        return (
            <div
                style={{ padding: "24px", textAlign: "center", color: "#666" }}
            >
                {t("dhb.player.recap.no_matches")}
            </div>
        );
    }

    const sortOrderFor = (col) => (sortColumn === col ? sortOrder : undefined);

    return (
        <div className={tableStyles.recapTableWrap}>
            <Table skin="dark">
                <Header skin="dark">
                    <HeaderCell>#</HeaderCell>
                    {SORT_COLUMNS.map((col) => (
                        <HeaderCell
                            key={col}
                            name={col}
                            onClick={() => handleSort(col)}
                            sortOrder={sortOrderFor(col)}
                        >
                            {t(COL_TRANSLATION_KEYS[col])}
                        </HeaderCell>
                    ))}
                    <HeaderCell>
                        {t("dhb.player.recap.column.match_id")}
                    </HeaderCell>
                    <HeaderCell>
                        {t("dhb.player.recap.column.staff")}
                    </HeaderCell>
                </Header>
                <Body>
                    {sortedRows.map((row, rowIndex) => {
                        return (
                            <Row key={rowIndex}>
                                <Cell>{rowIndex + 1}</Cell>
                                <Cell>
                                    {row.date
                                        ? Moment(row.date).format("DD.MM.YYYY")
                                        : "—"}
                                </Cell>
                                <Cell>{row.leagueName ?? "—"}</Cell>
                                <Cell>{row.team ?? "—"}</Cell>
                                <Cell>{renderMatchStatus(row.status)}</Cell>
                                <Cell>
                                    <Button
                                        skin="link"
                                        onClick={() =>
                                            onMatchClick(row.matchId)
                                        }
                                    >
                                        {row.matchId}
                                    </Button>
                                </Cell>
                                <Cell>
                                    {row.isStaff ? (row.staffRole ?? "") : ""}
                                </Cell>
                            </Row>
                        );
                    })}
                </Body>
            </Table>
            <div className={tableStyles.legendWrap}>
                <RecapLegend />
            </div>
        </div>
    );
};

export default PlayerRecapTable;
